<template>
  <div>
    <a-card :head-style="{ background: 'rgb(243, 243, 243)' }">
      <template #title>
        <div>用户详情</div>
      </template>
      <div class="modal_ct">
        <a-row :gutter="16" class="_row">
          <div class="wrapper">
            <img src="@/assets/1.jpg" style="width: 100px; heihgt: 100px" />
            <br />
            <a-button>黄金会员</a-button>
          </div>
        </a-row>
        <div>
          <a-row :gutter="16" class="ar">
            <a-col :span="8" class="bgl"> 用户ID </a-col>
            <a-col :span="8" class="bgr">{{ obj.id }} </a-col>
          </a-row>
          <a-row :gutter="16" class="ar">
            <a-col :span="8" class="bgl"> 联系人姓名 </a-col>
            <a-col :span="8" class="bgr"> {{ obj.companyContact }}</a-col>
          </a-row>
          <a-row :gutter="16" class="ar">
            <a-col :span="8" class="bgl"> 手机号码 </a-col>
            <a-col :span="8" class="bgr">{{ obj.phone }} </a-col>
          </a-row>

          <a-row :gutter="16" class="ar">
            <a-col :span="8" class="bgl"> 会员等级 </a-col>
            <a-col :span="8" class="bgr"> {{ level }}</a-col>
          </a-row>
          <a-row :gutter="16" class="ar">
            <a-col :span="8" class="bgl"> 城市 </a-col>
            <a-col
              :span="12"
              class="bgr"
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              >{{ formating(obj.city) }}
            </a-col>
          </a-row>
        </div>
        <div>
          <a-row :gutter="16" class="ar">
            <a-col :span="8" class="bgl"> 类型 </a-col>
            <a-col :span="8" class="bgr">{{ purpose }} </a-col>
          </a-row>

          <a-row :gutter="16" class="ar">
            <a-col :span="8" class="bgl"> 备注 </a-col>
            <a-col :span="8" class="bgr">{{ obj.remark }} </a-col>
          </a-row>
          <a-row :gutter="16" class="ar">
            <a-col :span="8" class="bgl"> 扣点 </a-col>
            <a-col :span="12" class="bgr"> {{ points }}</a-col>
          </a-row>
          <a-row :gutter="16" class="ar">
            <a-col :span="8" class="bgl"> 开户时间 </a-col>
            <a-col :span="12" class="bgr">{{ obj.time }} </a-col>
          </a-row>
          <a-row :gutter="16" class="ar">
            <a-col :span="8" class="bgl"> 用户来源 </a-col>
            <a-col :span="8" class="bgr"> {{ userSource }}</a-col>
          </a-row>
        </div>
      </div>
      <!-- 统计信息 -->
      <br />
      <a-card :head-style="{ background: 'rgb(243, 243, 243)' }">
        <template #title><CopyOutlined />&nbsp;统计信息</template>
        <a-table
          :columns="columns"
          :dataSource="data"
          :pagination="false"
        ></a-table>
      </a-card>
      <br />
      <a-card :head-style="{ background: 'rgb(243, 243, 243)' }">
        <template #title><CopyOutlined />&nbsp;收货地址</template>
        <a-table :columns="columns2"></a-table>
      </a-card>
      <br />
      <a-card :head-style="{ background: 'rgb(243, 243, 243)' }">
        <template #title><CopyOutlined />&nbsp;订单记录</template>
        <a-table :columns="columns1"></a-table>
      </a-card>
    </a-card>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { CopyOutlined } from "@ant-design/icons-vue";
import supply from "@/axios/supply";
import { reactive } from "@vue/reactivity";
import { computed } from "@vue/runtime-core";
export default {
  components: {
    CopyOutlined,
  },
  setup() {
    let route = useRoute();
    let obj = reactive({});
    supply.getSupplyDetail(route.query.id).then((item) => {
      obj.id = item.id;
      obj.phone = item.contactPhone;
      obj.city = item.companyCity;
      obj.time = item.createTime;
      obj.level = item.userLevel;
      obj.userSource = item.userSource;
      obj.userName = item.username;
      obj.remark = item.remark;
      obj.points = item.points;
      obj.purpose = item.purpose;
      obj.companyContact = item.companyContact;
    });
    let level = computed(() => {
      return obj.level == 0
        ? "普通会员"
        : obj.level == 1
        ? "黄金会员"
        : obj.level == 2
        ? "白金会员"
        : "钻石会员";
    });
    let purpose = computed(() => {
      return obj.purpose == 0 ? "TMC" : obj.purpose == 1 ? "分销" : "电商";
    });

    let points = computed(() => {
      return obj.points == 0
        ? "无"
        : obj.points == 1
        ? "接口供应商贴扣点"
        : "实体供应商";

      //* 扣点设置      * 0 无      * 1 接口供应商贴扣点      * 2 实体供应商
    });
    let userSource = computed(() => {
      return obj.userSource == 0 ? "PC" : obj.userSource == 1 ? "H5" : "App";
    });

    let formating = (val) => {
      if (val) {
        let reg = /\d/g;
        let str = val.replace(reg, "");
        let reg1 = /\:/g;
        let str1 = str.replace(reg1, "");
        let reg2 = /"""/g;
        let str2 = str1.replace(reg2, "");
        let reg3 = /"/g;
        let str3 = str2.replace(reg3, "");
        let reg4 = /{/g;
        let str4 = str3.replace(reg4, "");
        let reg5 = /}/g;
        let str5 = str4.replace(reg5, "");
        let reg6 = /,/g;
        let str6 = str5.replace(reg6, "");
        return str6;
      }

      // let reg = /\:/g;
      // let str = val.replace(reg, "");
      // console.log(str);
      // let reg2 = /\d/g;
      // let str2 = str1.replace(reg2, "");
      // let reg3 = /,/g;
      // let str3 = str2.replace(reg3, "");
      // let reg4 = /""/g;
      // let str4 = str3.replace(reg4, "");
      // let reg5 = /{"||"}/g;
      // let str5 = str4.replace(reg5, "");
      // let reg6 = /"}/g;
      // let str6 = str5.replace(reg6, "");
      // return str6;
    };
    return {
      formating,
      userSource,
      points,
      purpose,
      level,
      obj,
      columns: [
        {
          title: "充值金额",
          dataIndex: "price",
          align: "center",
        },
        {
          title: "授权余额",
          dataIndex: "maxPrice",
          align: "center",
        },
        {
          title: "授信额度上限",
          dataIndex: "max",
          align: "center",
        },
        {
          title: "授信额度下限",
          dataIndex: "min",
          align: "center",
        },
        {
          title: "登录次数",
          dataIndex: "login",
          align: "center",
        },
      ],
      data: [
        {
          price: "$1000",
          maxPrice: "1000",
          max: "10",
          min: "10",
          login: "10",
        },
      ],
      columns2: [
        {
          title: "姓名",
        },
        {
          title: "手机号码",
        },
        {
          title: "详细地址",
        },
        {
          title: "邮政编码",
        },
        {
          title: "默认地址",
        },
      ],
      columns1: [
        {
          title: "订单编号",
        },
        {
          title: "提交时间",
        },
        {
          title: "用户账号",
        },
        {
          title: "订单数量",
        },
        {
          title: "支付方式",
        },
        {
          title: "订单来源",
        },
        {
          title: "订单状态",
        },
        {
          title: "操作",
        },
      ],
      route,
    };
  },
};
</script>

<style lang='scss' scoped>
/deep/ .ant-card-head-title {
  padding: 10px 0;
  font-size: 14px;
}
/deep/ .ant-card-body {
  padding: 10px;
}
.modal_ct {
  display: flex;
  justify-content: flex-start;
  & > div {
    width: 50%;
    & > .ar:first-child {
      border-top: 1px solid #e4e4e4 !important;
    }
  }

  .bgl {
    background: #f9fafc;
    text-align: right;
    line-height: 40px;
  }
  .bgr {
    text-align: left;
    line-height: 40px;
    color: #000;
  }
  .ar {
    border: 1px solid #e4e4e4;
    border-top: none;
    color: #666666;
  }
}
.modal_ct /deep/ .ant-row {
  margin: 0 !important;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 51px;
  background: #f9fafc;
}
._row {
  background: #f9fafc;
  border: 0.1px solid #e4e4e4;
  border-right: none;
}
</style>